export default __webpack_public_path__ + "static/media/website.ee44ca45.png";